<section class="ng-business-banner">
  <div class="content-wrapper">
    <h2 class="over-title">{{ overTitle }}</h2>
    <h1 class="title" [innerHTML]="title"></h1>
    <p class="sub-title">{{ subtitle }}</p>
  </div>
  <div class="ng-image">
    <picture>
      <source media="(min-width: 1280px)" [attr.srcset]="image.desktop" />
      <source media="(min-width: 720px)" [attr.srcset]="image.tablet" />
      <img [src]="image.mobile" [alt]="image.alt" />
    </picture>
  </div>
</section>
